import { ModalFooter } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { FC, useCallback, useEffect, useState } from "react";
import { config } from "../config";
import { useApiClient } from "@hostingbv/lib/src/api";
import { Input } from "@hostingbv/lib/src/components/form/Input";
import { Autocomplete } from "@hostingbv/lib/src/components/form/Autocomplete";
import countries from 'i18n-iso-countries'
import { Customer } from "@hostingbv/lib/src/api/common/models/Customer";

export const EditCustomerModal: FC<{ customer: Customer }> = ({ customer }) => {
  const countryOptions = countries.getNames('en')
  const { partnerClient } = useApiClient(config)

  const [name, setName] = useState(customer.displayName)
  const [street, setStreet] = useState(customer.addressStreet)
  const [number, setNumber] = useState(customer.addressNumber)
  const [zip, setZip] = useState(customer.addressZip)
  const [city, setCity] = useState(customer.addressCity)
  const [country, setCountry] = useState(customer.addressCountry)
  const [referenceNumber, setReferenceNumber] = useState(customer.referenceNumber ?? '')
  const [error, setError] = useState('')

  useEffect(() => {
    if (customer) {
      setName(customer?.displayName ?? '')
      setStreet(customer?.addressStreet ?? '')
      setNumber(customer?.addressNumber ?? '')
      setZip(customer?.addressZip ?? '')
      setCity(customer?.addressCity ?? '')
      setCountry(customer?.addressCountry ?? '')
      setReferenceNumber(customer?.referenceNumber ?? '')
    }
  }, [customer])

  const save = useCallback(async () => {
    if (!customer) {
      console.warn('Customer not loaded...')
      return
    }
    await partnerClient.updateCustomer(customer.id, {
      display_name: name,
      address_street: street,
      address_number: number,
      address_zip: zip,
      address_city: city,
      address_country: country,
      ...(referenceNumber === "" ? {} : { reference_number: referenceNumber }),
    }).then(result => {
      if (!result.success) {
        setError(result.error)
        throw new Error(result.error)
      }
    })
  }, [name, street, number, zip, city, country, referenceNumber, customer])

  return <>
    <form onSubmit={() => save()} className={"space-y-4 flex-1"}>
      <div className={"flex items-center max-w-md space-x-4"}>
        <Input label={"Name"} type={"text"} value={name} onChange={(v) => setName(v)} />
      </div>
      <div className={"flex items-center max-w-md space-x-4"}>
        <Input label={"Street"} type={"text"} value={street} onChange={(v) => setStreet(v)} />
        <Input label={"Number"} type={"text"} value={number} onChange={(v) => setNumber(v)} />
      </div>
      <div className={"flex items-center max-w-md space-x-4"}>
        <Input label={"Zipcode"} type={"text"} value={zip} onChange={(v) => setZip(v)} />
        <Input label={"City"} type={"text"} value={city} onChange={(v) => setCity(v)} />
      </div>
      <div className={"flex items-center max-w-md space-x-4"}>
        <Autocomplete label={"Country"} value={country} options={countryOptions} onChange={(v) => setCountry(v)} />
      </div>
      <div className={"flex items-center max-w-md space-x-4"}>
        <Input label={"Reference number (optional)"} type={"text"} value={referenceNumber} onChange={(v) => setReferenceNumber(v)} />
      </div>
      {error.length > 0 && <div className={"font-medium text-red-600"}>
        {error}
      </div>}
    </form>
    <ModalFooter text={"Save"} onSubmit={save} />
  </>
}
